
export default {
  props: {
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    defaultPageSize: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    change(current) {
      this.$emit('change', current)
    },
  },
}
